// extracted by mini-css-extract-plugin
export var header = "_w3-1";
export var maskBottom = "_w3-6";
export var maskMiddle = "_w3-7";
export var maskTop = "_w3-5";
export var root = "_w3-0";
export var scrollDownButton = "_w3-3";
export var scrollDownButtonHidden = "_w3-4";
export var viewport = "_w3-2";